import { EventEmitter } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { StoreService } from '../store.service';
import { PlatformLocation } from '@angular/common';
import { CommonService } from '../common.service';
var UserAvailableAskingComponent = (function () {
    function UserAvailableAskingComponent(commonService, router, location, apiService, storeService) {
        this.commonService = commonService;
        this.router = router;
        this.location = location;
        this.apiService = apiService;
        this.storeService = storeService;
        this.outPutHeartBeatStatus = new EventEmitter();
        this.timer = null;
        this.timeOneMinuteAgo = "";
        //控制对话框的样式
        this.dialogDisplay = 'none';
        this.dialogOpacity = 0;
        // Stephen add 2025-03-07
        this.isTencent = false;
    }
    UserAvailableAskingComponent.prototype.openDialog = function () {
        var _this = this;
        if (this.authInvalid) {
            //设置时间,其他地方登录
            var timeStaOneMinAge = new Date().valueOf() - 60 * 1000;
            var date = new Date(timeStaOneMinAge);
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var hoursStr = hours < 10 ? '0' + hours : hours;
            var minutesStr = minutes < 10 ? '0' + minutes : minutes;
            this.timeOneMinuteAgo = hoursStr + ":" + minutesStr;
            this.outPutHeartBeatStatus.emit(false);
        }
        this.dialogDisplay = 'block';
        setTimeout(function () {
            _this.dialogOpacity = 1;
        }, 0);
    };
    UserAvailableAskingComponent.prototype.closeDialog = function () {
        var _this = this;
        this.dialogOpacity = 0;
        setTimeout(function () {
            _this.dialogDisplay = 'none';
        }, 0);
    };
    UserAvailableAskingComponent.prototype.openCourseInvalidBox = function () {
        this.courseInvalid = true;
        this.openDialog();
    };
    // status===0 时，需同时确认 coachAuthority 为 false 才视为账号过期可弹窗
    UserAvailableAskingComponent.prototype.shouldShowAccountExpiredByAuthority = function () {
        return this.commonService.getUserCheckAuthority().then(function (result) {
            var shouldShow = !(result && result.coachAuthority);
            console.log('---checkAuthority coachAuthority:', result && result.coachAuthority, '是否弹窗:', shouldShow);
            return shouldShow;
        }).catch(function (err) {
            console.log('---checkAuthority 请求失败，不弹账号过期窗', err);
            return false;
        });
    };
    UserAvailableAskingComponent.prototype.checkValidAccountDoSth = function () {
        var _this = this;
        this.apiService.getCompanyList().subscribe(function (result) {
            var validCompanyList = result.filter(function (item) { return item.state === 1; });
            var validCount = validCompanyList.length;
            if (validCount > 1) {
                _this.nextStep = ['course-select'];
                _this.openCourseInvalidBox();
            }
            else if (validCount === 1) {
                _this.nextStep = validCompanyList[0].id;
                _this.openCourseInvalidBox();
            }
            else {
                //导航至404页面
                _this.goToLearnigMapOrNothingPage();
            }
        });
    };
    UserAvailableAskingComponent.prototype.startAtimer = function (duration) {
        var _this = this;
        clearTimeout(this.timer); //先清除timer执行环境
        this.timer = setTimeout(function () {
            console.log('---当前用户状态轮询一次');
            //请求当前user的id接口
            //如果请求失败（401）则会被全局的监测捕获未授权状态，不必继续轮询
            _this.apiService.getUserInfo().subscribe(function (res) {
                //处理当前课程状态
                if (res && res.status === 0) {
                    //无效用户：再校验教练权限，无权限才弹
                    _this.shouldShowAccountExpiredByAuthority().then(function (shouldShow) {
                        if (shouldShow) {
                            _this.checkValidAccountDoSth();
                        }
                    });
                }
                if (res && res.status === 1) {
                    localStorage.setItem('userId', res.id);
                    $('#userIdContainer').val(res.id);
                    _this.storeService.notification.refreshHomePage.next(true);
                }
                if (res && !('id' in res)) {
                    //userId关联失败,其他地方登录
                    _this.openDialog(); //打开重定向倒计时模态
                    return;
                }
                _this.startAtimer(duration); //下一次轮询
            });
        }, duration);
    };
    UserAvailableAskingComponent.prototype.getAskingDuration = function () {
        var _this = this;
        return new Promise(function (resolve, rejection) {
            _this.apiService.getUserStatusAskingDuration().subscribe(function (res) {
                resolve(res);
            });
        });
    };
    UserAvailableAskingComponent.prototype.goToLoginPage = function () {
        this.closeDialog(); //关闭对话框
        //还原状态
        this.initTipState();
        this.router.navigate(['new-login']);
        this.commonService.removeStorage('transtalen-token');
        this.commonService.removeStorage('transtalenuserid');
        //还原授权状态为初始值null
        this.storeService.notification.notAuthed.next(null);
    };
    UserAvailableAskingComponent.prototype.goToLearnigMapOrNothingPage = function () {
        if (this.location.pathname === '/learning-map') {
            //已经在首页了。刷新一下,确保出现nothing-page
            this.location.location.reload();
        }
        else {
            //go to home page
            this.router.navigate(['learning-map']);
        }
    };
    UserAvailableAskingComponent.prototype.goToLearnigMapOrCourseSelect = function () {
        this.closeDialog(); //关闭对话框
        //还原状态
        this.initTipState();
        this.goToLoginPage();
        //判断应该去哪里
        // if(Array.isArray(this.nextStep)){
        //   //路径
        //   this.router.navigate(this.nextStep)
        // }else if(typeof this.nextStep === 'number'){
        //   //是公司ID
        //   this.loginWithCompanyIdDirectly(this.nextStep)
        // }else{
        //   this.goToLearnigMapOrNothingPage()
        // }
    };
    UserAvailableAskingComponent.prototype.loginWithCompanyIdDirectly = function (companyId) {
        var _this = this;
        var loginData = {};
        try {
            loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
        }
        catch (e) {
            loginData = {};
        }
        var token = localStorage.getItem('transtalen-token');
        var sendData = this.commonService.buildCompanyReloginPayload(loginData, companyId, {
            switchCompany: !!token,
            token: token || ''
        });
        this.apiService.loginInPhoneOrAccount(sendData, { withToken: !!token }).subscribe(function (result) {
            _this.goToLearnigMapOrNothingPage();
        });
    };
    UserAvailableAskingComponent.prototype.initTipState = function () {
        this.authInvalid = false;
        this.courseInvalid = false;
    };
    UserAvailableAskingComponent.prototype.checkValidAccountDoSthNotReloadpage = function () {
        var _this = this;
        console.log('---checkValidAccountDoSthNotReloadpage 被调用');
        this.apiService.getCompanyList().subscribe(function (result) {
            var validCompanyList = result.filter(function (item) { return item.state === 1; });
            var validCount = validCompanyList.length;
            console.log('---有效公司数量:', validCount);
            if (validCount > 1) {
                _this.nextStep = ['course-select'];
                console.log('---多个有效公司，准备弹窗');
                _this.openCourseInvalidBox();
            }
            else if (validCount === 1) {
                _this.nextStep = validCompanyList[0].id;
                console.log('---一个有效公司，准备弹窗');
                _this.openCourseInvalidBox();
            }
            else {
                console.log('---没有有效公司，弹出账号失效提示');
                // 没有有效公司时，弹出登录失效的提示
                _this.authInvalid = true;
                _this.openDialog();
            }
        });
    };
    UserAvailableAskingComponent.prototype.initAskImmediately = function () {
        var _this = this;
        this.askImmediately = this.storeService.notification.askImmediately.subscribe(function (value) {
            if (value === true) {
                console.log('learning-map页立即询问一次---');
                //需要立即执行一次
                _this.apiService.getUserInfo().subscribe(function (res) {
                    //处理当前课程状态
                    if (res && res.status === 0) {
                        //无效用户：再校验教练权限，无权限才弹
                        _this.shouldShowAccountExpiredByAuthority().then(function (shouldShow) {
                            if (shouldShow) {
                                _this.checkValidAccountDoSthNotReloadpage();
                            }
                        });
                    }
                    if (res && !('id' in res)) {
                        //userId关联失败,其他地方登录
                        _this.openDialog(); //打开重定向倒计时模态
                        return;
                    }
                });
            }
        });
    };
    UserAvailableAskingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isTencent = this.commonService.checkAndSetModuleId();
        this.initAskImmediately();
        // 立即执行一次用户状态检查
        this.checkUserStatusImmediately();
        // 获取轮询间隔并启动定时器
        this.getAskingDuration().then(function (res) {
            console.log('message:轮询间隔为---', res);
            _this.startAtimer(res * 1000);
        });
        //监听全部接口的未授权通知
        this.storeService.notification.notAuthed.subscribe(function (d) {
            if (d === true) {
                console.log('接口未授权,在其他地方登录-----', d);
                _this.authInvalid = true;
                _this.openDialog(); //打开重定向倒计时模态
            }
        });
    };
    // 立即检查用户状态
    UserAvailableAskingComponent.prototype.checkUserStatusImmediately = function () {
        var _this = this;
        console.log('---组件初始化，立即检查用户状态一次');
        this.apiService.getUserInfo().subscribe(function (res) {
            console.log('---getUserInfo 返回结果:', res);
            //处理当前课程状态
            if (res && res.status === 0) {
                console.log('---用户状态为0（无效用户），校验 coachAuthority');
                //无效用户：再校验教练权限，无权限才弹账号过期
                _this.shouldShowAccountExpiredByAuthority().then(function (shouldShow) {
                    if (shouldShow) {
                        console.log('---coachAuthority 为 false，立即弹窗');
                        _this.courseInvalid = true;
                        _this.openDialog();
                    }
                    else {
                        console.log('---coachAuthority 为 true，不弹账号过期窗');
                    }
                });
                return;
            }
            if (res && res.status === 1) {
                console.log('---用户状态为1（正常用户）');
                //正常用户
                localStorage.setItem('userId', res.id);
                $('#userIdContainer').val(res.id);
                _this.storeService.notification.refreshHomePage.next(true);
                return;
            }
            if (res && !('id' in res)) {
                console.log('---用户无id（其他地方登录），立即弹窗');
                //userId关联失败,其他地方登录
                _this.authInvalid = true;
                _this.openDialog(); //打开重定向倒计时模态
                return;
            }
        });
    };
    UserAvailableAskingComponent.prototype.ngOnDestroy = function () {
        this.askImmediately.unsubscribe(); //取消订阅
        clearTimeout(this.timer);
        console.log('---清除当前用户状态轮询');
    };
    return UserAvailableAskingComponent;
}());
export { UserAvailableAskingComponent };



// WEBPACK FOOTER //
// ./src/app/user-available-asking/user-available-asking.component.ts.pre-build-optimizer.js